import { createContext, useReducer } from "react"
import AuthReducer from "./authReducer"

const INITIAL_STATE = {
    org:localStorage.getItem('org')!=="null"? JSON.parse(localStorage.getItem('org')) : null,
    user: localStorage.getItem('user')!=="null"? JSON.parse(localStorage.getItem('user')) : null,
    isFetching: false,
    error: false,
}

export const AuthContext = createContext(INITIAL_STATE)

export const AuthContextProvider = ({children}) => {
    const [state, dispatch] = useReducer(AuthReducer, INITIAL_STATE);
    return (
        <AuthContext.Provider value={{org: state.org, user: state.user, isFetching: state.isFetching, error: state.error, dispatch}}>
         {children}
        </AuthContext.Provider>
    )
}